<template>
  <component :is="tag" class="poster" :href="href ? href : false" :class="modifiers">
    <img v-bind="src" class="poster__image" />
    <button v-if="isVideo" type="button" class="poster__play" @click="$emit('play')">
      <BaseIcon v-if="isVideo" name="play" class="poster__play-icon" />
    </button>
  </component>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseLink from '@/components/BaseLink.vue';

export default {
  name: 'BasePoster',
  components: {
    BaseIcon,
    BaseLink,
  },
  props: {
    href: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: 'jpg',
    },
    isRound: {
      type: Boolean,
      default: true,
    },
    isVideo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        poster_round: this.isRound,
        poster_video: this.isVideo,
      };
    },
    src() {
      return {
        src: require(`@/assets/images/${this.name}.${this.format}`), // eslint-disable-line
        srcset: require(`@/assets/images/${this.name}@2x.${this.format}`), // eslint-disable-line
        alt: this.alt,
      };
    },
    tag() {
      if (this.href) return BaseLink;
      return 'div';
    },
  },
};
</script>

<style lang="stylus">
.poster
  display block
  overflow hidden
  &_round
    border-radius 1em
  &_video
    position relative
    &:before
      content ''
      display block
      padding-top 56%
  &__image
    display block
    width 100%
    ~/_video &
      abs top left
      width 100%
      height 100%
      object-fit cover
      object-position center
  &__play
    display block
    abs top 50% left 50%
    width 3em
    height 3em
    padding 0
    background none
    border 0
    outline none
    margin (@height / 2 * -1) 0 0 (@width / 2 * -1)
    color $c_bright
    z-index 1

  &__play-icon
    display block
    width 100%
    height 100%
    fill #fff
    &:hover
      fill $c_bright
      color #fff
</style>
